<template>
  <!-- ✅ SOLICITAR AJUSTE -->
  <c-q-btn
    v-if="authStore.currentUserCanReviewInstitutional
      && institutionalStore.institutionalDetail?.status == CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id"
    id="btn-request-adjustments"
    propBtnLabel="Solicitar Ajuste"
    :propBtnFunction="onRequestAdjustmentsBtnClick"
    :propBtnTransparent="true"
    :propBtnSize="EnumButtonSizes.LARGE_1"
  />

  <!-- ✅ SOLICITAR REAJUSTE -->
  <c-q-btn
    v-if="authStore.currentUserCanReviewInstitutional
      && institutionalStore.institutionalDetail?.status == CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id"
    id="btn-request-adjustments"
    propBtnLabel="Solicitar Reajuste"
    :propBtnFunction="onRequestAdjustmentsBtnClick"
    :propBtnTransparent="true"
    :propBtnSize="EnumButtonSizes.LARGE_1"
  />
</template>

<script setup lang="ts">
import { EnumRequestedAdjustmentsInstitucionalModalType, EnumButtonSizes } from '@/enums/enums'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const institutionalStore = useInstitutionalStore()

const onRequestAdjustmentsBtnClick = () => {
  pagesUtilStore.modalRequestedAdjustmentsInstitucionalModalType =
    EnumRequestedAdjustmentsInstitucionalModalType.CREATE
  pagesUtilStore.showModalRequestAdjustmentsInstitucional = true
}
</script>
